import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'nrwl-data-display-dialog',
  templateUrl: './data-display-dialog.component.html',
  styleUrls: ['./data-display-dialog.component.scss']
})
export class DataDisplayDialogComponent implements OnInit {
  status = [];
  constructor(
    private dialogRef: MatDialogRef<DataDisplayDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[]
  ) {}

  ngOnInit(): void {
    if(this.data) {
      this.status = this.data;
    }
  }

  close(): any {
    this.dialogRef.close();
  }
}
